import { render, staticRenderFns } from "./CarInsurableExtras.vue?vue&type=template&id=fa82fdd6&"
import script from "./CarInsurableExtras.vue?vue&type=script&lang=js&"
export * from "./CarInsurableExtras.vue?vue&type=script&lang=js&"
import style0 from "./CarInsurableExtras.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports